import checkbox from '../../../../checkbox';

const light = (params) => checkbox.switchedOff.background.default.light(params);

export default light;
